import axios from '../axios';

/**
 * 登录请求
 * 
 * @url /users/checkLogin
 * 
 * @param { String } account    账号
 * @param { String } password   密码
 */

export function checkLogin(params) {
    return axios.post('/auth/login', params)
}

/**
 * 获取图形验证码
 * 
 * @url /users/Getverification
 * 
 * 
 */

export function Getverification() {
    return axios.get('/auth/captcha')
}

/**
 * 短信发送
 * 
 * @url /users/SendSMS
 * 
 * @param { String } verify_code  图形验证码
 * @param { String } mobile  手机号码
 */

export function SendSMS(params) {
    return axios.post('/auth/send', params)
}
/**
 * 短信验证码登录
 * 
 * @url /auth/login_sms
 * 
 */

export function authloginsms(params) {
    return axios.post('/auth/login_sms', params)
}
/**
 * 注册
 * 
 * @url /auth/register
 * 
 */

export function authregister(params) {
    return axios.post('/auth/register', params)
}
/**
 * 修改密码
 * 
 * @url /auth/change_pwd
 * 
 */

export function authchangepwd(params) {
    return axios.post('/auth/change_pwd', params)
}

/**
 * 获取平台信息
 * 
 * @url /config
 * 
 * 
 */

export function config() {
    return axios.get('/config')
}
/**
 * 二维码
 * 
 * @url /auth/qr
 * 
 */

export function authqr() {
    return axios.get('/auth/qr')
}

/**
 * 应用信息
 * 
 * @url /api/config
 * 
 */

export function apiconfig() {
    return axios.get('/config')
}
